//Handler to change STUDENT copy to LEARNER
export const studentToLearner = (role) => {
  if (role === 'Student') {
    return 'Learner'
  } else {
    return role;
  }
};

